import { Box, BoxProps } from '@mui/material';

type BrProps = BoxProps;
export const Br = ({ ...rest }: BrProps) => {
  return <Box component="br" {...rest} />;
};
